import { render, staticRenderFns } from "./addgroup-form.vue?vue&type=template&id=22d12632&scoped=true"
import script from "./addgroup-form.vue?vue&type=script&lang=js"
export * from "./addgroup-form.vue?vue&type=script&lang=js"
import style0 from "./addgroup-form.vue?vue&type=style&index=0&id=22d12632&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d12632",
  null
  
)

export default component.exports